module.exports = __webpack_public_path__ + "img/visit_ing.20ccf367.png";